import axios from 'axios';
import { ICurrentUserRepository } from '../../application/ports/ICurrentUserRepository';
import { CurrentUserEntity } from '../../domain/entities/CurrentUser';
import { advertizerApiHost } from '../../constants/envs';
import { AuthTokenProvider } from '../auth/AuthTokenProvider';
import { mapApiToEntity } from '../mappers/currentUser.mapper';

export class CurrentUserAxiosRepository implements ICurrentUserRepository {
  constructor(private auth: AuthTokenProvider) {}

  private async authHeaders() {
    const token = await this.auth.getToken();
    if (!token) throw new Error('Unauthenticated');
    return { Authorization: `Bearer ${token}` };
  }

  async get(): Promise<CurrentUserEntity> {
    const headers = await this.authHeaders();
    const res = await axios.get(advertizerApiHost + '/api/users/me', { headers });
    return mapApiToEntity(res.data);
  }
}
